import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Input, message, Space, Tooltip, Popconfirm } from 'antd';
import { BE_HOST } from "../../config/config";
import './GLP1Management.css';  // Add this import
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import Chat from '../../components/chats/Chat';
import { useSelector } from 'react-redux';
const GLP1Management = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [form, setForm] = useState({ ndc_code: '', drug_name: '' });
  const [chatBoxOpen, setChatOpen] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);

  const fetchData = async (params = {}) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BE_HOST}/api/glp?page=${params.current - 1}&limit=${params.pageSize}`
      );
      const result = await response.json();
      if (result.success) {
        setData(result.data);
        setPagination({
          ...params,
          total: result.total || 0,
        });
      } else {
        message.error('Failed to fetch data');
      }
    } catch (error) {
      message.error('Error fetching data');
      console.error('Error fetching data:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(pagination);
  }, []);

  const handleTableChange = (newPagination) => {
    fetchData(newPagination);
  };

  const showModal = (record = null) => {
    if (record) {
      setForm({ ndc_code: record.ndc_code, drug_name: record.drug_name });
      setEditRecord(record);
    } else {
      setForm({ ndc_code: '', drug_name: '' });
      setEditRecord(null);
    }
    setIsModalVisible(true);
  };

  const handleSave = async () => {
    try {
      if (!form.ndc_code || !form.drug_name) {
        message.error('Both NDC Code and Drug Name are required');
        return;
      }

      let response;
      if (editRecord) {
        // Using old_ndc_code for the URL parameter
        response = await fetch(`${BE_HOST}/api/glp/glp1-list/${editRecord.ndc_code}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ndc_code: form.ndc_code,
            drug_name: form.drug_name
          }),
        });
      } else {
        response = await fetch(`${BE_HOST}/api/glp/glp1-list`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(form),
        });
      }

      const result = await response.json();
      if (result.success) {
        message.success(result.message);
        setIsModalVisible(false);
        fetchData(pagination);
      } else {
        message.error(result.message || 'Operation failed');
      }
    } catch (error) {
      message.error('Operation failed');
      console.error('Error:', error);
    }
  };

  const handleDelete = async (ndc_code) => {
    try {
      const response = await fetch(`${BE_HOST}/api/glp/glp1-list/${ndc_code}`, {
        method: 'DELETE',
      });
      const result = await response.json();
      
      if (result.success) {
        message.success(result.message);
        fetchData(pagination);
      } else {
        message.error(result.message || 'Failed to delete record');
      }
    } catch (error) {
      message.error('Failed to delete record');
      console.error('Error:', error);
    }
  };

  const columns = [
    {
      title: 'NDC Code',
      dataIndex: 'ndc_code',
      key: 'ndc_code',
      width: '40%',
    },
    {
      title: 'Drug Name',
      dataIndex: 'drug_name',
      key: 'drug_name',
      width: '40%',
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '20%',
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit Record">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => showModal(record)}
            />
          </Tooltip>
          <Tooltip title="Delete Record">
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={() => handleDelete(record.ndc_code)}
              okText="Yes"
              cancelText="No"
            >
              <Button 
                type="text"
                danger
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div>
<div className="p-4">
<div className="flex justify-between mb-4" style={{ padding: "16px 16px 0 16px" }}>
        <h1 className="text-2xl font-bold">GLP-1 Master</h1>

      {/* <div className="mb-4"> */}
      <Space>
      <Tooltip title="Add New Record">
        <Button 
          type="primary" 
          onClick={() => showModal()} 
          className="bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
        >
          Add New Record
        </Button>
        </Tooltip>
        </Space>
            
        </div>
      {/* </div> */}

      <Table
        columns={columns}
        dataSource={data}
        rowKey="ndc_code"
        pagination={{
          ...pagination,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`
        }}
        onChange={handleTableChange}
        loading={loading}
        scroll={{ x: true }}
        className="custom-table user-tbl"
      />

      </div>
       {/* {userAuth?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
                <div className="chat-button" onClick={() => setChatOpen(true)}>
                  💬 Let’s Chat
                </div>
              )}
              <Chat
                      open={chatBoxOpen}
                      setOpen={setChatOpen}
                    /> */}

      <Modal
        title={editRecord ? "Edit Record" : "Add New Record"}
        open={isModalVisible}
        onOk={handleSave}
        onCancel={() => setIsModalVisible(false)}
        className="custom-modal"
        centered
        width={500}
        footer={
          <div className="flex justify-end space-x-2">
            <Button 
              key="cancel" 
              onClick={() => setIsModalVisible(false)}
              className="border-[#1a2352] text-[#1a2352] min-w-[80px]"
            >
              Cancel
            </Button>
            <Button 
              key="submit" 
              type="primary" 
              onClick={handleSave}
              className="bg-[#0EA5E9] hover:bg-[#0EA5E9]/90 min-w-[80px]"
            >
              {editRecord ? 'Update' : 'Save'}
            </Button>
          </div>
        }
      >
        <div className="space-y-4 py-4">
          <div className="mb-4">
            <label className="block mb-2 text-[#000833] font-medium">NDC Code</label>
            <Input
              value={form.ndc_code}
              onChange={(e) => setForm({ ...form, ndc_code: e.target.value })}
              disabled={!!editRecord}
              placeholder="Enter NDC Code"
              className=""
            />
          </div>
          <div>
            <label className="block mb-2 text-[#000833] font-medium">Drug Name</label>
            <Input
              value={form.drug_name}
              onChange={(e) => setForm({ ...form, drug_name: e.target.value })}
              placeholder="Enter Drug Name"
              className=""
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GLP1Management;